var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 12,
    viewBox: "0 0 4 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00033 3.33332C2.73366 3.33332 3.33366 2.73332 3.33366 1.99999C3.33366 1.26666 2.73366 0.666656 2.00033 0.666656C1.26699 0.666656 0.666992 1.26666 0.666992 1.99999C0.666992 2.73332 1.26699 3.33332 2.00033 3.33332ZM2.00033 4.66666C1.26699 4.66666 0.666992 5.26666 0.666992 5.99999C0.666992 6.73332 1.26699 7.33332 2.00033 7.33332C2.73366 7.33332 3.33366 6.73332 3.33366 5.99999C3.33366 5.26666 2.73366 4.66666 2.00033 4.66666ZM2.00033 8.66666C1.26699 8.66666 0.666992 9.26666 0.666992 9.99999C0.666992 10.7333 1.26699 11.3333 2.00033 11.3333C2.73366 11.3333 3.33366 10.7333 3.33366 9.99999C3.33366 9.26666 2.73366 8.66666 2.00033 8.66666Z",
    fill: "#5C715E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more_icon.56cb3f7b9534423e78c74f7f94ba765c.svg";
export { ForwardRef as ReactComponent };